export default {
  name: 'shop-info',
  label: {
    title: '店铺信息',
    icon: require('@/assets/icon-component-label_ShopInfo.svg'),
    limit: 1
  },
  tip: '注意：此模块只在店铺首页显示，微页面中不显示',
  decor_type: 'seller',
  sort: 2002
}
